export const isUndefined = (data: any): boolean => {
  return typeof data === 'undefined';
}